import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 30 30"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M21.448 8.555a2.736 2.736 0 0 1-.142-3.716.227.227 0 0 0-.012-.309l-2.586-2.588a.228.228 0 0 0-.322 0l-4.122 4.121a1.383 1.383 0 0 0-.334.542 1.387 1.387 0 0 1-.876.879c-.205.068-.39.182-.542.334L1.942 18.386a.228.228 0 0 0 0 .322l2.586 2.586a.227.227 0 0 0 .308.012 2.736 2.736 0 0 1 3.858 3.858.227.227 0 0 0 .012.308l2.586 2.586a.228.228 0 0 0 .322 0l10.57-10.57c.153-.152.267-.337.335-.541a1.386 1.386 0 0 1 .876-.88c.204-.067.39-.182.542-.334l4.121-4.122a.228.228 0 0 0 0-.322l-2.585-2.585a.227.227 0 0 0-.309-.013 2.736 2.736 0 0 1-3.716-.136Z",
  stroke: "currentColor",
  "stroke-miterlimit": "10"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "m14.678 8.229-.968-.967m3.547 3.546-.645-.644m3.224 3.224-.644-.645m3.546 3.547-.967-.968",
  stroke: "currentColor",
  "stroke-miterlimit": "10",
  "stroke-linecap": "round"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }